import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { type AccessRule, canAccess, getHomeRoute } from './access-control';
import { GlobalOverlayService } from '../ui/global-overlay.service';

export const accessGuard: CanActivateFn = async (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const overlay = inject(GlobalOverlayService);
  const rule = route.data['access'] as AccessRule | undefined;

  if (!auth.user()) {
    return router.createUrlTree(['/login']);
  }

  const homeRoute = getHomeRoute(auth.user());
  if (route.routeConfig?.path === 'dashboard' && homeRoute !== '/dashboard') {
    return router.createUrlTree([homeRoute]);
  }

  if (canAccess(auth.user(), rule)) return true;

  overlay.error('ไม่มีสิทธิ์เข้าถึง', 'คุณไม่มีสิทธิ์เข้าถึงหน้านี้ ระบบจะพาไปหน้าหลัก');
  return router.createUrlTree([homeRoute]);
};
